/* eslint-disable no-new */
export default {
    /**
     * Updates or inserts a form
     * @param {Object} others Store parameters
     * @param {Object} payload Payload of the action
     * @param {String} payload.id Form identifier
     * @param {Object} payload.properties Form data
     */
    upsertForm({ commit, getters }, payload) {
        if (getters.hasForm(payload.id)) {
            commit('UPDATE_FORM', payload);
        } else {
            commit('INSERT_FORM', payload);
        }
    },
    /**
     * Deletes a form
     * @param {Object} others Store parameters
     * @param {String} id Form identifier
     */
    deleteForm({ commit, getters }, id) {
        if (getters.hasForm(id)) {
            commit('DELETE_FORM', id);
        }
    },
    /**
     * Deletes all forms in a route
     * @param {Object} others Store parameters
     * @param {String} route Route name
     */
    deleteRouteForms({ commit, getters }, route) {
        if (getters.hasRoute(route)) {
            commit('DELETE_ROUTE_FORMS', route);
        }
    },
    /**
     * Deletes a form
     * @param {Object} others Store parameters
     * @param {String} id Form identifier
     */
    deleteAllForms({ commit }) {
        commit('DELETE_ALL_FORMS');
    }
};
